export default __webpack_public_path__ + "static/media/services_cammera_area.c7ba6cd7.svg";